function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.04 2C3.467 2 3 2.448 3 3v18.25c0 .414.35.75.78.75h.521c.431 0 .78-.336.78-.75V14H20.48c.463 0 .695-.539.367-.854l-5.098-4.899a.34.34 0 010-.494l5.098-4.9c.328-.314.096-.853-.367-.853H4.04z",
  fill: "url(#flag_svg__paint0_linear)"
});

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "flag_svg__paint0_linear",
  x1: 6.375,
  y1: 2,
  x2: 20.553,
  y2: 4.918,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#89A6BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#68869F"
})));

var SvgFlag = function SvgFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgFlag;